module.exports = __webpack_public_path__ + "img/DISCOUNT.26194218.svg";